import FilterListList from 'common/pages/filter-list/FilterListList'

export const FilterListListAdmin = (props: any) =>
    <FilterListList {...props} admin />